import React, { Component, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import filterFactory, {
  textFilter,
  selectFilter,
} from "react-bootstrap-table2-filter";
import { Tooltip } from "@material-ui/core";
import moment from "moment";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Form,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import "assets/scss/table.scss";
import {
  getSchemeAnalytesList,
  postMicroValue,
  getMicroValueList,
  getmicroresultdata,
} from "store/results/actions";
import "assets/scss/table.scss";
class MicroResults extends Component {
  constructor(props) {
    super(props);
    this.fileInput = React.createRef();
    this.node = React.createRef();
    this.state = {
      SchemeAnalytesList: [],
      combinedData: [],
      list: "",
      organism: "",
      antibiotic: "",
      Antibiotic: [],
      result: "",
      schemeName: "",
      microresults: "",
      selectedFile: null,
      selectedFileName: "",
      schemeType: "",
      comments: "",
      roundLoadedFor: null,
      loading: true,
      roundLoadedFor: null,
      round_status: "",
      result_status: "Created",
      antibioticValue: 0,
      checkedAntibioticCount: 0, // ✅ new
      rounds: "",
      issue_date: "",
      closing_date: "",
      cycle_no: "",
      isResubmitted: false,
      PostResult: [],
      fileMissing: false,
      currentRoundId: props.match.params.id,
      ResultList: [],
      isDataLoaded: false,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
    };
  }

  getApprovedLabListColumns = () => {
    const { schemeType } = this.props;

    if (schemeType === "Identification") {
      return [
        {
          text: "Antibiotic ",
          dataField: "antibiotic_name",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#f8f9fa" }, // 🔹 Light grey background
          align: "left",
          formatter: (cell, row) => <span>{row.antibiotic_name}</span>,
        },
        {
          text: "Resistant (R) ",
          dataField: "resistance",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#fff3f3" }, // 🔹 Light red shade
          align: "center",
          formatter: (cellContent, list, rowIndex) => (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`resistance-${rowIndex}`}
                checked={list.resistance || false}
                onChange={() => this.handleCheckboxToggle(list, "resistance")}
              />
            </div>
          ),
        },
        {
          text: "Intermediate (I)",
          dataField: "intermediate",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#fffbea" }, // 🔹 Light yellow shade
          align: "center",
          formatter: (cellContent, list, rowIndex) => (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`intermediate-${rowIndex}`}
                checked={list.intermediate || false}
                onChange={() => this.handleCheckboxToggle(list, "intermediate")}
              />
            </div>
          ),
        },
        {
          text: "Sensitive (S)",
          dataField: "sensitive",
          sort: true,
          headerStyle: {
            color: "#212529",
            backgroundColor: "#a6d4ff",
            textAlign: "center",
          },
          style: { backgroundColor: "#eafaf1" }, // 🔹 Light green shade
          align: "center",
          formatter: (cellContent, list, rowIndex) => (
            <div className="form-check d-flex justify-content-center">
              <input
                className="form-check-input"
                type="checkbox"
                id={`sensitive-checkbox-${rowIndex}`}
                checked={list.sensitive || false}
                onChange={() => this.handleCheckboxToggle(list, "sensitive")}
              />
            </div>
          ),
        },
      ];
    }
  };
  componentDidMount() {
    const roundId = this.props.match.params.id;
    const userId = this.state.user_id;

    if (!userId) return;

    this.props.onGetSchemeAnalyte(roundId);

    // Only call MicroValueList after round info is loaded
    if (roundId) {
      this.props.onGetMicroValueList(roundId);
    }

    if (userId && this.props.scheme && this.props.round_name) {
      this.props.onGetMicroresult(
        userId,
        this.props.scheme,
        this.props.round_name
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      SchemeAnalytesList,
      ListAntibiotic,
      ListOrganism,
      ResultList,
      MicroValueList, // <-- include here
      round_status,
      scheme,
      round_name,
    } = this.props;

    const { user_id, isDataLoaded, roundLoadedFor } = this.state;
    const prevRoundId = prevProps.match.params.id;
    const currentRoundId = this.props.match.params.id;
    const roundChanged = currentRoundId !== roundLoadedFor;

    // 🔄 Round changed
    if (prevRoundId !== currentRoundId) {
      this.props.clearResultsState();
      this.props.clearAnalyteState();

      this.setState({
        isDataLoaded: false,
        combinedData: [],
        roundLoadedFor: null,
        loading: true,
        SchemeAnalytesList: [],
        ListAntibiotic: [],
        ListOrganism: [],
        ResultList: [],
        round_status: null,
      });

      if (user_id) {
        this.props.onGetSchemeAnalyte(currentRoundId);
        this.props.onGetMicroresult(user_id, scheme, round_name);
        this.props.onGetMicroValueList(currentRoundId);
      }
      return;
    }

    // 👤 First time user_id appears
    if (!prevState.user_id && user_id) {
      const id = this.props.match.params.id;
      this.props.onGetSchemeAnalyte(id);
      this.props.onGetMicroresult(user_id, scheme, round_name);
      this.props.onGetMicroValueList(id);
      return;
    }

    // ✅ When scheme/round_name become available later
    if (
      scheme &&
      round_name &&
      (scheme !== prevProps.scheme || round_name !== prevProps.round_name)
    ) {
      this.props.onGetMicroresult(user_id, scheme, round_name);
    }

    const allListsReady =
      ListAntibiotic?.length > 0 && ListOrganism?.length > 0;

    if (allListsReady && (!isDataLoaded || roundChanged)) {
      this.setState(
        {
          SchemeAnalytesList,
          ListAntibiotic,
          ListOrganism,
          ResultList,
          MicroValueList, // <-- save into state
          round_status,
          isDataLoaded: true,
          roundLoadedFor: currentRoundId,
        },
        this.combineDataWithMicroValueList // <-- merge here
      );
      return;
    }

    const dataChanged = [
      prevProps.SchemeAnalytesList !== SchemeAnalytesList,
      prevProps.ListAntibiotic !== ListAntibiotic,
      prevProps.ListOrganism !== ListOrganism,
      prevProps.round_status !== round_status,
      prevProps.MicroValueList !== MicroValueList, // <-- watch this
    ].some(Boolean);

    if (dataChanged && isDataLoaded) {
      this.setState(
        {
          SchemeAnalytesList,
          ListAntibiotic,
          ListOrganism,
          ResultList,
          MicroValueList,
          round_status,
        },
        this.combineDataWithMicroValueList // <-- rebuild
      );
    }
  }

  combineDataWithMicroValueList = () => {
    const { MicroValueList = [], ListAntibiotic = [] } = this.props;

    console.log("🐛 Raw MicroValueList from API:", MicroValueList);
    console.log("🐛 Raw ListAntibiotic from props:", ListAntibiotic);

    let selectedOrganism = "";
    let selectedOrganismName = "";
    let checkedAntibioticCount = 0; // 👈 default

    if (MicroValueList.length > 0 && MicroValueList[0].organism) {
      const orgName = MicroValueList[0].organism;
      const matchedOrg = this.props.ListOrganism.find(
        (o) => o.name === orgName
      );

      selectedOrganism = matchedOrg ? matchedOrg.id : "";
      selectedOrganismName = matchedOrg ? matchedOrg.name : orgName;

      // 👇 read count from API response
      checkedAntibioticCount = MicroValueList[0].checked_antibiotic_count || 0;
    }

    const combinedData =
      MicroValueList.length > 0
        ? MicroValueList.map((item, idx) => {
            const row = {
              id: item.id,
              antibiotic_id: item.antibiotic_id || null,
              antibiotic_name: item.antibiotic_name || "",
              resistance: item.value === "R",
              intermediate: item.value === "I",
              sensitive: item.value === "S",
              antibiotic_value: item.antibiotic_value || 0,
              organism: item.organism || "",
              organism_value: item.organism_value || 50,
              checkedAntibioticCount: item.checked_antibiotic_count || 0, // 👈 add per-row
              result_status: "Submitted",
              comment: "",
            };
            console.log(`🧬 Combined row [${idx}]:`, row);
            return row;
          })
        : ListAntibiotic.map((ab, idx) => ({
            id: ab.id,
            antibiotic_id: ab.id,
            antibiotic_name: ab.name,
            resistance: false,
            intermediate: false,
            sensitive: false,
            antibiotic_value: 0,
            organism: "",
            organism_value: 50,
            checkedAntibioticCount: 0, // 👈 default
            result_status: "Created",
            comment: "",
          }));

    console.log("✅ Final CombinedData:", combinedData);

    this.setState({
      combinedData,
      loading: false,
      antibioticValue:
        MicroValueList.length > 0
          ? parseFloat(MicroValueList[0].antibiotic_value || 0)
          : 0,
      selectedOrganism,
      selectedOrganismName,
      checkedAntibioticCount, // 👈 store count in state
    });
  };

  handleAntibioticChange = (e, row) => {
    const value = e.target.value;
    const updatedData = this.state.combinedData.map((item) =>
      item.id === row.id ? { ...item, antibiotic_id: value } : item
    );
    this.setState({ combinedData: updatedData });
  };
  combineData = () => {
    const { ResultList = [] } = this.props;
    if (ResultList.length > 0) {
      const firstResult = ResultList[0];

      // ✅ Find the matching organism object from ListOrganism
      const matchedOrg = this.props.ListOrganism.find(
        (o) => o.name === firstResult.organism
      );

      this.setState({
        selectedOrganism: matchedOrg ? matchedOrg.id : "",
        selectedOrganismName: matchedOrg ? matchedOrg.name : "",
        selectedFileName: firstResult.result_sheet
          ? firstResult.result_sheet.split("/").pop() // extract just file name
          : "",
      });
    }

    const combinedData =
      ResultList.length > 0
        ? ResultList.map((item, index) => ({
            id: index + 1,
            antibiotic_name: item.antibiotic_name || "",
            resistance: item.resistance === true,
            intermediate: item.intermediate === true,
            sensitive: item.sensitive === true,
            comment: item.comment || "",
            result_status: item.result_status || "Submitted",
            organism: item.organism || "",
          }))
        : this.props.ListAntibiotic.map((ab, index) => ({
            id: ab.id,
            antibiotic_id: ab.id,
            antibiotic_name: ab.name,
            resistance: false,
            intermediate: false,
            sensitive: false,
          }));

    this.setState({ combinedData, loading: false });
  };
  handleCheckboxToggle = (item, field) => {
    const updatedData = this.state.combinedData.map((row) => {
      const isSameRow =
        (row.id && row.id === item.id) ||
        (!row.id && row.antibiotic_name === item.antibiotic_name);

      if (isSameRow) {
        // if the field is already true → uncheck it
        if (row[field] === true) {
          return {
            ...row,
            [field]: false,
          };
        }

        // otherwise → check this one, uncheck others
        return {
          ...row,
          resistance: false,
          intermediate: false,
          sensitive: false,
          notTested: false,
          [field]: true,
        };
      }
      return row;
    });

    // 🔥 Count how many antibiotics are selected (any checked R/I/S)
    const selectedAntibiotics = updatedData.filter(
      (row) => row.resistance || row.intermediate || row.sensitive
    );
    const checkedCount = selectedAntibiotics.length; // ✅ new

    // ✅ Divide 50 by number of selected antibiotics
    const antibioticValue =
      checkedCount > 0 ? parseFloat((50 / checkedCount).toFixed(2)) : 0;

    // 🟢 Update state with table + antibiotic value + checked count
    this.setState({
      combinedData: updatedData,
      antibioticValue,
      checkedAntibioticCount: checkedCount, // ✅ save to state
    });
  };

  onPaginationPageChange = (page) => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };
  handleSubmitAll = async () => {
    const { scheme_id, round_id, onPostMicroValue, onGetMicroValueList } =
      this.props;
    const {
      combinedData,
      user_id,
      selectedOrganism,
      selectedOrganismName,
      antibioticValue,
    } = this.state;

    if (!scheme_id || !round_id) {
      alert("Scheme ID or Round ID is missing.");
      return;
    }

    if (!combinedData || combinedData.length === 0) {
      alert("No results to submit.");
      return;
    }

    this.setState({ loading: true });

    try {
      // Build antibiotics list
      const antibiotics = combinedData.map((item) => {
        const value = item.resistance
          ? "R"
          : item.intermediate
          ? "I"
          : item.sensitive
          ? "S"
          : item.notTested
          ? "NT"
          : null;

        return {
          id: item.antibiotic_id,
          name: item.antibiotic_name,
          value,
          antibioticValue: antibioticValue,
        };
      });

      // ✅ Count only antibiotics with a selected value
      const checkedAntibioticCount = antibiotics.filter(
        (ab) => ab.value !== null
      ).length;

      // Final payload
      const payload = {
        user_id,
        scheme_id,
        round_id,
        organism: {
          id: selectedOrganism,
          name: selectedOrganismName,
        },
        antibiotics,
        checkedAntibioticCount, // 👈 added here
      };

      console.log("🚀 Final Payload to API:", payload);

      const response = await onPostMicroValue(payload);
      console.log("✅ Response:", response);

      // 🔥 Refresh list after post
      await onGetMicroValueList(round_id);

      // Optional: recombine immediately with fresh props
      this.combineDataWithMicroValueList();

      alert("Results submitted successfully!");
    } catch (error) {
      console.error("🔥 Error submitting results:", error);
      alert("Error occurred while submitting results.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const approvedLabListColumns = this.getApprovedLabListColumns();
    const id = this.props.match.params.id;
    const { SearchBar } = Search;
    const { combinedData, isDataLoaded } = this.state;
    const {
      schemeName,
      microresults,
      scheme_id,
      schemeType,
      rounds,
      issue_date,
      closing_date,
      cycle_no,
      round_status,
    } = this.props;
    const { loading } = this.state;

    if (loading) {
      return (
        <div className="text-center mt-5">
          <h5>Loading round data...</h5>
        </div>
      );
    }

    const pageOptions = {
      sizePerPage: 50,
      totalSize: combinedData.length > 0 ? combinedData.length : " ",
      custom: true,
    };

    if (!isDataLoaded) {
      // return <div>Loading...</div>;
    }
    if (!this.state.isDataLoaded) {
      return <div className="text-center mt-5">Loading round data...</div>;
    }
    const defaultSorted = [
      {
        dataField: "name", // or scheme_name, name, etc.
        order: "asc", // A to Z
      },
    ];

    const { organization_name } = this.props.match.params;
    const participant_id = this.props.match.params.id1;
    return (
      <React.Fragment>
        {schemeType ? (
          <div className="page-content">
            <MetaTags>
              <title>MICRO ASSIGNED VALUES | NEQAS</title>
            </MetaTags>
            <Container fluid>
              <Row className="mb-3">
                <Col className="text-start">
                  <Button
                    color="primary"
                    onClick={() => this.props.history.goBack()}
                  >
                    ← Back
                  </Button>
                </Col>
              </Row>
              <Row>
                <p
                  style={{
                    whiteSpace: "nowrap",
                    width: "320px",
                    marginLeft: "140px",
                    color: "black",
                  }}
                >
                  <strong>
                    Note: The organism value is 50, and the Antibiotic marks
                    (50) will be equally divided among the selected Antibiotics
                  </strong>
                </p>
              </Row>
              <Row className="text-dark fs-6">
                <strong>
                  <Col className="d-flex flex-wrap justify-content-md-around justify-content-sm-start  p-3">
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Scheme - Cycle: </span>
                      <span>
                        ({schemeName}) - {cycle_no}
                      </span>
                    </div>

                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Round No: </span>
                      <span>{rounds}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start mb-2 mb-md-0 p-2">
                      <span className="me-2">Issue Date:</span>
                      <span>{moment(issue_date).format("DD-MMM-YY")}</span>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-start p-2">
                      <span className="me-2">Closing Date: </span>
                      <span>{moment(closing_date).format("DD-MMM-YY")}</span>
                    </div>
                  </Col>
                </strong>
              </Row>
              <Row
                className="align-items-center mb-3 g-2"
                style={{ marginLeft: "25px", marginRight: "25px" }}
              >
                <Col md={6} className="d-flex justify-content-end gap-2">
                  {(() => {
                    const allSubmitted =
                      this.state.combinedData.length > 0 &&
                      this.state.combinedData.every(
                        (data) => data.result_status === "Submitted"
                      );

                    return <></>;
                  })()}
                </Col>

                <Row></Row>
                <Row>
                  <Col>
                    <p
                      style={{
                        whiteSpace: "nowrap",
                        width: "320px",
                        marginLeft: "100px",
                      }}
                    >
                      <strong>Organism Value: 50</strong>
                    </p>
                  </Col>
                  <Col>
                    <p
                      style={{
                        whiteSpace: "nowrap",
                        width: "320px",
                        // marginLeft: "20px",
                      }}
                    >
                      <strong>
                        Value Marks for each Antibiotic:{" "}
                        <span style={{ color: "green", fontWeight: "bold" }}>
                          {this.state.antibioticValue}
                        </span>
                      </strong>
                    </p>
                  </Col>
                  <Col>
                    <p style={{ whiteSpace: "nowrap", width: "320px" }}>
                      <strong>
                        How many Antibiotics checked:{" "}
                        <span style={{ color: "blue", fontWeight: "bold" }}>
                          {this.state.checkedAntibioticCount}
                        </span>
                      </strong>
                    </p>
                  </Col>
                </Row>

                <Row className="mt-3 text-dark">
                  <Col md={6}>
                    <div className="d-flex align-items-center">
                      <label
                        className="form-label mb-0 me-2"
                        style={{
                          whiteSpace: "nowrap",
                          width: "320px",
                          marginLeft: "100px",
                        }} // keep text in one line
                      >
                        <strong>Select Organism:</strong>
                      </label>
                      <select
                        className="form-control"
                        value={this.state.selectedOrganism}
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const org = this.props.ListOrganism.find(
                            (o) => o.id == selectedId
                          );
                          this.setState({
                            selectedOrganism: selectedId,
                            selectedOrganismName: org ? org.name : "",
                          });
                        }}
                      >
                        <option
                          value=""
                          style={{ fontSize: "12px", color: "#888" }}
                        >
                          Select Organism
                        </option>
                        {this.props.ListOrganism?.map((org) => (
                          <option key={org.id} value={org.id}>
                            {org.name} ({org.code})
                          </option>
                        ))}
                      </select>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        className="p-2"
                        color="primary"
                        style={{
                          minWidth: "120px",
                          fontWeight: "500",
                          marginRight: "80px",
                        }}
                        onClick={this.handleSubmitAll}
                      >
                        Submit
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Row>

              <Row className="justify-content-center align-item-center">
                <Col lg="10">
                  <Card>
                    <CardBody>
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                        keyField="id"
                        columns={approvedLabListColumns}
                        data={combinedData}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={approvedLabListColumns}
                            data={combinedData}
                            search
                          >
                            {(toolkitprops) => (
                              <React.Fragment>
                                <div className="table-responsive">
                                  <BootstrapTable
                                    id="printable-table" // Added ID here
                                    keyField="id"
                                    ref={this.node}
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    classes={"table table-bordered "}
                                    {...toolkitprops.baseProps}
                                    {...paginationTableProps}
                                  />
                                  <div className="float-end">
                                    <PaginationListStandalone
                                      {...paginationProps}
                                      onPageChange={this.onPaginationPageChange}
                                    />
                                  </div>
                                </div>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        ) : (
          <div>No scheme type available</div>
        )}
      </React.Fragment>
    );
  }
}
MicroResults.propTypes = {
  match: PropTypes.object,
  data: PropTypes.any,
  schemeName: PropTypes.string,
  microresults: PropTypes.string,
  schemeType: PropTypes.string,
  SchemeAnalytesList: PropTypes.array,
  rounds: PropTypes.string,
  round_status: PropTypes.string,
  scheme_id: PropTypes.number,
  issue_date: PropTypes.string,
  closing_date: PropTypes.string,
  cycle_no: PropTypes.string,
  ListAntibiotic: PropTypes.array,
  ListOrganism: PropTypes.array,
  PostResult: PropTypes.array,
  ResultList: PropTypes.array,
  className: PropTypes.any,
  onGetSchemeAnalyte: PropTypes.func,
  onGetMicroresult: PropTypes.func,
  onPostMicroValue: PropTypes.func,
  // onGetResultsList: PropTypes.func,
  clearResultsState: PropTypes.func,
  clearAnalyteState: PropTypes.func,
  history: PropTypes.object.isRequired,
  scheme: PropTypes.object, // or more specific if you know the shape
  round_name: PropTypes.string,
  participant_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  round_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  round_status: PropTypes.string, // optional, if used
  dispatch: PropTypes.func.isRequired,
  onGetMicroValueList: PropTypes.func.isRequired, // ✅ new
  MicroValueList: PropTypes.array,
};
const mapStateToProps = (state) => {
  const schemeState = state.SchemeAnalytesList || {};
  const antibiotics = schemeState.ListAntibiotic || [];

  console.log("🧪 Antibiotic List in mapStateToProps:", antibiotics);
  console.log(
    "🧬 MicroValueList in mapStateToProps:",
    schemeState.MicroValueList || []
  );

  return {
    schemeName: schemeState.schemeName,
    schemeType: schemeState.schemeType,
    rounds: schemeState.rounds,
    issue_date: schemeState.issue_date,
    closing_date: schemeState.closing_date,
    round_status: schemeState.round_status,
    cycle_no: schemeState.cycle_no,
    scheme_id: schemeState.scheme_id,
    microresults: schemeState.microresults,
    ResultList: schemeState.ResultList,
    SchemeAnalytesList: schemeState.SchemeAnalytesList || [],
    scheme: schemeState.schemeName,
    round_name: schemeState.rounds,
    ListOrganism: schemeState.ListOrganism || [],
    ListAntibiotic: schemeState.ListAntibiotic || [],
    round_id: schemeState.round_id,

    // ✅ FIX: pull from same slice
    MicroValueList: schemeState.MicroValueList || [],
  };
};

const mapDispatchToProps = (dispatch) => ({
  onGetSchemeAnalyte: (id) => dispatch(getSchemeAnalytesList(id)),
  onPostMicroValue: (formData, id) => dispatch(postMicroValue(formData, id)),
  onGetMicroresult: (userId, scheme, round_name) =>
    dispatch(getmicroresultdata(userId, scheme, round_name)),
  onGetMicroValueList: (id) => dispatch(getMicroValueList(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MicroResults));
